<template>
  <div>
    <b-form-checkbox
      plain
      id="propertyDelivered"
      name="propertyDelivered"
      v-model="getForm.propertyDelivered"
      class="form-group row"
      value="1"
      unchecked-value="null"
    >Bâtiment livré</b-form-checkbox>

    <b-form-group
      label="Date livraison bâtiment"
      label-cols="4"
      label-for="dateOfPropertyDelivery"
      class="form-table"
    >
      <b-form-input
        id="dateOfPropertyDelivery"
        name="dateOfPropertyDelivery"
        type="date"
        v-model="getForm.dateOfPropertyDelivery"
      />
      <span class="input-group-addon">
        <i class="fa fa-calendar"></i>
      </span>
    </b-form-group>
    <b-form-group
      label="Date prochaine visite"
      label-cols="4"
      label-for="dateOfNextVisit"
      class="form-table"
    >
      <b-form-input
        id="dateOfNextVisit"
        name="dateOfNextVisit"
        type="date"
        v-model="getForm.dateOfNextVisit"
      />
      <span class="input-group-addon">
        <i class="fa fa-calendar"></i>
      </span>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  Name: 'SpecificVpt',
  computed: {
    ...mapGetters(['getForm']),
  },
  data: function() {
    return {
      id: '',
    };
  },
};
</script>
